import {combineReducers} from 'redux';
import settings from './settings';
import combinations from './combinations';
import players from './players';

const reducers = {
    settings,
    combinations,
    players,
};

export default combineReducers(reducers);
